// tslint:disable
/**
 * respondeco.org
 * API description of respondeco.org
 *
 * The version of the OpenAPI document: 1.2.5
 * Contact: klaus@respondeco.org
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
  import {
    Account,
    AccountFromJSON,
    AccountToJSON,
    Credentials,
    CredentialsFromJSON,
    CredentialsToJSON,
    ImpersonationRequest,
    ImpersonationRequestFromJSON,
    ImpersonationRequestToJSON,
    ImpersonationResponse,
    ImpersonationResponseFromJSON,
    ImpersonationResponseToJSON,
  } from '../models';

      export interface ImpersonateUserRequest {
        impersonationRequest?: ImpersonationRequest;
      }

      export interface LoginRequest {
        credentials?: Credentials;
      }


/**
* no description
*/
export interface AuthenticationApi {
    /**
      * Get currently logged in user
    */
    getLogin(): Promise<Account>
    /**
      * Get an authentication token for the given accountId
    */
    impersonateUser(requestParameters: ImpersonateUserRequest): Promise<ImpersonationResponse>
    /**
      * Authenticate
    */
    login(requestParameters: LoginRequest): Promise<Account>
    /**
      * Logout
    */
    logout(): Promise<void>
}

  /**
  * no description
  */
  export class AuthenticationApiImpl extends runtime.BaseAPI implements AuthenticationApi {

    /**
      * Get currently logged in user
    */
    async getLoginRaw(): Promise<runtime.ApiResponse<Account>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/auth/login`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => AccountFromJSON(jsonValue));
      }

      /**
        * Get currently logged in user
      */
      async getLogin(): Promise<Account> {
        const response = await this.getLoginRaw();
        return await response.value();
      }

    /**
      * Get an authentication token for the given accountId
    */
    async impersonateUserRaw(requestParameters: ImpersonateUserRequest): Promise<runtime.ApiResponse<ImpersonationResponse>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/auth/impersonate`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
              body: ImpersonationRequestToJSON(requestParameters.impersonationRequest),
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => ImpersonationResponseFromJSON(jsonValue));
      }

      /**
        * Get an authentication token for the given accountId
      */
      async impersonateUser(requestParameters: ImpersonateUserRequest): Promise<ImpersonationResponse> {
        const response = await this.impersonateUserRaw(requestParameters);
        return await response.value();
      }

    /**
      * Authenticate
    */
    async loginRaw(requestParameters: LoginRequest): Promise<runtime.ApiResponse<Account>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

      const response = await this.request({
      path: `/auth/login`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
              body: CredentialsToJSON(requestParameters.credentials),
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => AccountFromJSON(jsonValue));
      }

      /**
        * Authenticate
      */
      async login(requestParameters: LoginRequest): Promise<Account> {
        const response = await this.loginRaw(requestParameters);
        return await response.value();
      }

    /**
      * Logout
    */
    async logoutRaw(): Promise<runtime.ApiResponse<void>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/auth/logout`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Logout
      */
      async logout(): Promise<void> {
        await this.logoutRaw();
      }

    }
